<template>
  <div
    class="engine-template-wrapper hidden h5-swiper"
    :style="getProjectStyle"
  >
    <audio
      ref="bgMusicRef"
      v-if="pageData && pageData.backgroundMusic"
      :src="pageData.backgroundMusic"
      loop
      :autoplay="pageData.backgroundMusicAutoPlay ? true : false"
    ></audio>
    <div
      class="swiper-container"
      :style="
        getCommonStyle({
          ...getPage.commonStyle,
          backgroundSize:
            getPage.backgroundImageStyle == 2 ? '100% 100%' : 'auto 100%',
          backgroundRepeat: 'no-repeat',
        })
      "
    >
      <div class="swiper-wrapper" v-if="pageData">
        <div class="swiper-slide flat relative hidden">
          <div
            class="quark-page-wrapper"
            :style="
              getCommonStyle(
                {
                  ...getPage.commonStyle,
                  top: pageTop,
                  height: pageData.height,
                  width: pageData.width,
                  position: 'relative',
                  backgroundImage: 'none',
                },
                scalingRatio
              )
            "
          >
            <componentsGroupTemplate
              v-for="(item, index) in elementGroups.filter(
                (i) => !i.dynamicPanelUUID
              )"
              :key="index"
              :element="item"
              :elementsAll="elementsAll"
              :elementGroups="elementGroups"
              :scalingRatio="scalingRatio"
              :style="
                getCommonStyle(
                  {
                    ...item.defaultStyle,
                    zIndex: item.zIndex,
                    display: item.display ? item.display : 'block',
                  },
                  scalingRatio
                )
              "
              @router="changeRouter"
            >
            </componentsGroupTemplate>
            <componentsTemplate
              v-for="(item, index) in elements.filter(
                (i) => !i.dynamicPanelUUID
              )"
              :key="index"
              :loaded="item._loaded"
              :element="item"
              :elementsAll="elementsAll"
              :elementGroups="elementGroups"
              :scalingRatio="scalingRatio"
              :style="
                getCommonStyle(
                  {
                    ...(item.isDynamicPanel
                      ? { ...item.commonStyle, overflow: 'hidden' }
                      : item.commonStyle),
                  },
                  scalingRatio
                )
              "
              @router="changeRouter"
            >
              <dynamic-panel-self
                v-if="item.isDynamicPanel && !dynamicPanelStatesRefreshing"
                :item="item"
                :dynamicPanelStatesCheck="dynamicPanelStatesCheck"
                :elementsAll="elementsAll"
                :elementGroups="elementGroups"
                :scalingRatio="scalingRatio"
                @router="changeRouter"
              ></dynamic-panel-self>
            </componentsTemplate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCommonStyle } from "@/assets/js/utils";
import componentsTemplate from "./components-template";
import dynamicPanelSelf from "./dynamic-panel-self";
import componentsGroupTemplate from "./components-group-template";
import elementEvents from "@/assets/js/elementEvents";
// import $config from '@client/config'
export default {
  name: "engineH5Swiper",
  components: {
    componentsTemplate,
    componentsGroupTemplate,
    dynamicPanelSelf,
  },
  data() {
    return {
      getCommonStyle: getCommonStyle,
      scalingRatio: 1,
      pageData: {
        pages: [],
      },
      pageTop: 0,
      activeIndex: 0,
      elementsAll: [],
      elements: [],
      elementGroups: [],
      dynamicPanelStatesCheck: {},
      dynamicPanelStatesRefresh: 0,
    };
  },
  created() {
    this.init();
  },
  mixins: [elementEvents],
  computed: {
    getPage() {
      return this.activeIndex > -1
        ? this.pageData.pages[this.activeIndex]
        : {
            commonStyle: {},
            elements: [],
          };
    },
    getElementGroups() {
      return this.getPage.elementGroups;
    },
    getElements() {
      const elementGroups = this.getElementGroups.map((i) => i.list).flat();
      return this.getPage.elements.filter(
        (i) => !elementGroups.includes(i.uuid)
      );
    },
    getProjectStyle() {
      const style = {};
      if (this.pageData.backgroundColor) {
        style.backgroundColor = this.pageData.backgroundColor;
      }
      if (this.pageData.backgroundImage) {
        style.background = `url(${this.pageData.backgroundImage})`;
        style.backgroundPosition = "center";
        style.backgroundRepeat = "no-repeat";
        if (this.pageData.backgroundImageStyle == 2) {
          style.backgroundSize = "100% 100%";
        } else {
          style.backgroundSize = "auto 100%";
        }
      }
      return style;
    },
    dynamicPanelStatesRefreshing() {
      return this.dynamicPanelStatesRefresh;
    },
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage);
    this.parentPostMessage({
      type: "WINDOW_READY",
    });
    this.parentPostMessage({
      type: "ENTRY_FINISHED",
    });
    window.outListenerKeydown = ({ key }) => {
      key == "t" && this.bgMusicPlay();
      key == "y" && this.bgMusicPause();
    };
    if (!this.pageData.backgroundMusicAutoPlay) {
      this.bgMusicPause();
    } else {
      const playHandler = () => {
        window.removeEventListener("click", playHandler);
        this.bgMusicPlay();
      };
      window.addEventListener("click", playHandler);
    }
    window.bgMusicPlay = this.bgMusicPlay;
    window.bgMusicPause = this.bgMusicPause;
    window.receiveMessage = this.receiveMessage;
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    receiveMessage(e) {
      console.log(e.data, "receiveMessage - inner");
      // const _this = this;
      // let activeIndex;
      switch (e.data.type) {
        case "BG_MUSIC_PLAY":
          // 打开音乐
          this.bgMusicPlay();
          break;
        case "BG_MUSIC_PAUSE":
          // 静音
          this.bgMusicPause();
          break;
        case "ROUTE_GO":
          // 路由前进
          // updateRouteNeedPostMessage(0);
          // router.push({
          //   name: e.data.data.name,
          // });
          // activeIndex = _this.pageData.pages.findIndex(
          //   (i) => i.uuid == e.data.data.name
          // );
          // _this.pageDataInit(activeIndex);
          break;
      }
    },
    bgMusicPlay() {
      if (this.$refs["bgMusicRef"]) {
        this.$refs["bgMusicRef"].play();
        this.pageData.backgroundMusic &&
          document.removeEventListener("click", this.bgMusicPlay);
        this.parentPostMessage({
          type: "BG_MUSIC_PLAY",
        });
      }
    },
    bgMusicPause() {
      if (this.$refs["bgMusicRef"]) {
        this.$refs["bgMusicRef"].pause();
        this.parentPostMessage({
          type: "BG_MUSIC_PAUSE",
        });
      }
    },
    parentPostMessage(data) {
      if (window.self !== window.top) {
        parent.postMessage(data, "*");
      }
    },
    async init() {
      // this.scalingRatio = document.body.clientWidth / window._pageData.width;
      let widthAvailable = document.body.clientWidth;
      // todo 宽高比大于/小于16:9，做横向/竖向居中自适应
      if (document.body.clientWidth / document.body.clientHeight > 16 / 9) {
        // 更宽 - 以高度为基准 水平居中
        widthAvailable = document.body.clientHeight * (16 / 9);
      }
      this.scalingRatio = widthAvailable / window._pageData.width;
      let pageData = window._pageData,
        pageIndex = 0;
      const pid = new URLSearchParams(new URL(window.location.href).search).get(
        "pid"
      );
      if (pid) {
        pageIndex = pageData.pages.findIndex((i) => i.uuid == pid);
      }
      this.pageDataInit(pageIndex);
      window.dynamicPanelStateChange = this.dynamicPanelStateChange;
    },
    sleep(msec) {
      return new Promise((resolve) => setTimeout(resolve, msec));
    },
    pageDataInit(activeIndex) {
      let pageData = window._pageData;
      pageData.pages.map((page, index) => {
        page.elements.map((e) => {
          e._loaded = index === activeIndex;
        });
      });
      this.activeIndex = -1;
      this.elementsAll = [];
      this.elementGroups = [];
      this.elements = [];
      this.$nextTick(() => {
        setTimeout(() => {
          this.pageData = pageData;
          this.activeIndex = activeIndex;
          this.elementsAll = pageData.pages[activeIndex].elements;
          this.elementsAll
            .filter((i) => i.isDynamicPanel == 1)
            .map((i) => {
              !this.dynamicPanelStatesCheck[i.uuid] &&
                (this.dynamicPanelStatesCheck[i.uuid] = {});
              this.dynamicPanelStatesCheck[i.uuid].state = 0;
            });
          const elementGroupsFlat = pageData.pages[activeIndex].elementGroups
            ? pageData.pages[activeIndex].elementGroups
                .map((i) => i.list)
                .flat()
            : [];
          this.elementGroups = pageData.pages[activeIndex].elementGroups
            ? pageData.pages[activeIndex].elementGroups.map((i) => {
                return {
                  ...i,
                  list: i.list.map((m) =>
                    this.elementsAll.find((p) => p.uuid == m)
                  ),
                };
              })
            : [];
          this.elements = pageData.pages[activeIndex].elements.filter(
            (i) => !elementGroupsFlat.includes(i.uuid)
          );
          this.pageEvents();
          console.log(this.pageData, "this.pageData");
          console.log(
            pageData.pages[activeIndex].elementGroups,
            "pageData.pages[activeIndex].elementGroups"
          );
          console.log(this.elementGroups, "this.elementGroups");
          console.log(this.elements, "this.elements");
          console.log(this.elementsAll, "this.elementsAll");
          this.pageData.backgroundMusic &&
            document.addEventListener("click", this.bgMusicPlay);
        }, 0);
      });
    },
    async pageEvents() {
      const pageEvents = this.pageData.pages[this.activeIndex].events;
      if (pageEvents) {
        for (let i = 0, len = pageEvents.length; i < len; i++) {
          if (this["_event_" + pageEvents[i].type]) {
            await this["_event_" + pageEvents[i].type](pageEvents[i], this);
          }
        }
      }
    },
    async dynamicPanelStateChange(data) {
      console.log(data, "dynamicPanelStateChange");
      const {
        dynamicPanelUUID, // 目标UUID
        dynamicPanelStateUUID, // 目标stateUUID / next / prev
        dynamicPanelAnimationIn, // 进入动画
        dynamicPanelAnimationInMillisecond, // 进入动画时长
        dynamicPanelAnimationOut, // 退出动画
        dynamicPanelAnimationOutMillisecond, // 退出动画时长
        dynamicPanelLoop, // state是否循环
      } = data;
      const elementIndex = this.elementsAll.findIndex(
        (i) => i.uuid == dynamicPanelUUID
      );
      let currentState = this.dynamicPanelStatesCheck[dynamicPanelUUID].state;
      let nextState = -1;
      if (dynamicPanelStateUUID == "next") {
        if (currentState < this.elementsAll[elementIndex].states.length - 1) {
          nextState = currentState + 1;
        } else {
          if (dynamicPanelLoop) {
            nextState = 0;
          }
        }
      } else if (dynamicPanelStateUUID == "prev") {
        if (currentState > 0) {
          nextState = currentState - 1;
        } else {
          if (dynamicPanelLoop) {
            nextState = this.elementsAll[elementIndex].states.length - 1;
          }
        }
      } else {
        nextState = this.elementsAll[elementIndex].states.findIndex(
          (i) => i.uuid == dynamicPanelStateUUID
        );
      }
      if (nextState != -1 && nextState != currentState) {
        this.dynamicPanelStatesCheck[dynamicPanelUUID].state = nextState;
        this.dynamicPanelStatesCheck[dynamicPanelUUID].dynamicPanelAnimationIn =
          dynamicPanelAnimationIn;
        this.dynamicPanelStatesCheck[
          dynamicPanelUUID
        ].dynamicPanelAnimationInMillisecond =
          dynamicPanelAnimationInMillisecond;
        if (dynamicPanelAnimationOut) {
          const dynamicPanelSelfDom = document
            .getElementById(dynamicPanelUUID)
            .getElementsByClassName("qk-dynamic-panel-self")[0];
          dynamicPanelSelfDom.style.animationIterationCount = 1;
          dynamicPanelSelfDom.style.animationDelay = 0;
          dynamicPanelSelfDom.style.animationFillMode = "forwards";
          dynamicPanelSelfDom.style.animationName = dynamicPanelAnimationOut;
          if (dynamicPanelAnimationOutMillisecond) {
            dynamicPanelSelfDom.style.animationDuration = `${
              parseInt(dynamicPanelAnimationOutMillisecond) / 1000
            }s`;
            await this.sleep(
              Math.abs(dynamicPanelAnimationOutMillisecond - 100)
            );
          }
        }
        this.dynamicPanelStatesRefresh = 1;
        this.$nextTick(() => {
          this.dynamicPanelStatesRefresh = 0;
        });
      }
    },
    getDynamicPanelAnimationIn(uuid) {
      if (
        this.dynamicPanelStatesCheck[uuid] &&
        this.dynamicPanelStatesCheck[uuid].dynamicPanelAnimationIn
      ) {
        const css = {
          animationIterationCount: 1,
          animationDelay: 0,
          animationFillMode: "forwards",
          animationName:
            this.dynamicPanelStatesCheck[uuid].dynamicPanelAnimationIn,
        };
        if (
          this.dynamicPanelStatesCheck[uuid].dynamicPanelAnimationInMillisecond
        ) {
          css.animationDuration = `${
            parseInt(
              this.dynamicPanelStatesCheck[uuid]
                .dynamicPanelAnimationInMillisecond
            ) / 1000
          }s`;
        }
        return css;
      }
      return {};
    },
    changeRouter(pageUUID) {
      const activeIndex = this.pageData.pages.findIndex(
        (i) => i.uuid == pageUUID
      );
      // 无法使用JUMP_LINK，会导致页面重新载入，视频无法自动播放
      // this.parentPostMessage({
      //   type: "JUMP_LINK",
      //   url: this.$utils.changeURLArg(location.href, "pid", pageUUID),
      // });
      // 原通信方法被修改，按照新的解决方案考虑 todo...
      // this.parentPostMessage({
      //   type: "ROUTE_HISTORY",
      //   data: {
      //     domain: location.origin,
      //     href: location.href,
      //     name: pageUUID,
      //     index: 1,
      //   },
      // });
      this.pageDataInit(activeIndex);
    },
  },
};
</script>

<style scoped>
.engine-template-wrapper,
.swiper-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.relative {
  position: relative;
}
.hidden {
  overflow: hidden;
}
</style>
